import React, { PropsWithChildren } from 'react';
import {CepresTheme, CepresThemeProvider} from "theme";
import {ThemeProvider as EmotionThemeProvider} from "@emotion/react"

export default function ThemeProvider({ children }: PropsWithChildren) {
    return (
        <CepresThemeProvider>
        <EmotionThemeProvider theme={CepresTheme}>
            {children}
        </EmotionThemeProvider>
        </CepresThemeProvider>
    );
}
